import React from 'react';
// import BugReportIcon from '@material-ui/icons/BugReport';
import EmojiEventsIcon from '@material-ui/icons/EmojiEvents';


const Badges = () => {
  return(
      <div style={{textAlign: 'center'}}>
        <EmojiEventsIcon/>
        <EmojiEventsIcon/>
        <EmojiEventsIcon/>
      </div>
  )


}





export default Badges;